// src/component/promoBannerDefaults.js
//
// 「サイト上部プッシュ通知バナー／ダイアログ」の Firestore 設定が未設定の場合に
// 使う既定値、および設定ドキュメント名を集約。

export const PROMO_BANNER_CONFIG_DOC = "promoBanner";

// 表示対象（公開範囲）の種類
//  - "admin"  : 管理者のみ（テスト中などに利用）
//  - "phases" : audience.phases に含まれる paymentPhase を payments[] に持つユーザー
//  - "all"    : ログイン中の全ユーザー
// 管理者には設定にかかわらず常に表示する（プレビュー・運用のため）。
export const PROMO_BANNER_AUDIENCE = {
  ADMIN: "admin",
  PHASES: "phases",
  ALL: "all",
};

// 期の選択肢（payments[].paymentPhase の値と同じ）
export const PROMO_BANNER_PHASE_OPTIONS = [
  { id: "1", label: "1期（2023）" },
  { id: "2", label: "2期（2024）" },
  { id: "3", label: "3期（2025）" },
  { id: "4", label: "4期（2026）" },
];

export const PROMO_BANNER_DEFAULTS = {
  enabled: false,

  // 公開範囲
  audience: {
    mode: PROMO_BANNER_AUDIENCE.ADMIN,
    phases: [], // mode === "phases" のときに対象とする paymentPhase の配列
  },

  // 管理者の表示制限を無効化（テスト用）
  //  - true : 管理者は「1日1回」「今後表示しない」の影響を受けず、毎回開ける
  //  - false: 管理者にも他ユーザーと同じ制限を適用
  adminBypassLimits: true,

  // 左レール／モバイル右下フローティングのアイコンに出すツールチップ文言
  tooltipText: "周波数切り替えの大切なお知らせ",

  // チップ／小見出し
  chipLabel: "お知らせ",

  // タイトル（ダイアログの太字見出し）
  title: "夏至点のイベント優先受付中",

  // 本文（ダイアログのみ。改行はそのまま反映）
  body:
    "マスターマインドメンバーズ限定で、夏至点のイベントの優先受付を行っています。\n" +
    "詳細はリンクからご確認ください。",

  // 画像（任意）
  imageUrl: "",
  imagePath: "", // Storage 削除用

  // リンク
  linkUrl: "",
  linkLabel: "詳しく見る",

  // 表示終了日時（YYYY-MM-DDTHH:mm or YYYY-MM-DDTHH:mm:ss）
  // サーバ時刻基準で過ぎたら自動で非表示。空文字なら期限なし。
  expiresAt: "",

  // 管理画面で保存するたびにインクリメント。
  // ユーザーが「もう表示しない」した version より新しい version になったら、
  // 再度表示できるようにするための「リセット用バージョン」。
  version: 1,
};

// ユーザー側の表示状態を users/{uid}.promoBannerState に保存する。
//   - lastShownDate: "YYYY-MM-DD"  日次1回判定（ダイアログのみ）
//   - dismissedVersion: number     恒久的に閉じた version
export const PROMO_BANNER_USER_STATE_FIELD = "promoBannerState";
